import type { ToSnakeCaseKeys } from './common'
import type { FunnowProductProductResponse } from '@/types/api'

/** 方案販售類型, 銷售模式 -> 0:一般, 1:週末, 2:憑證, 3:外送, 4:酒類外送, 5:電影, 6: 露營 */
export const ProductSalesMode = Object.freeze({
  /** 0 一般 */
  Common: 0,
  /** 1 週末 */
  Weekend: 1,
  /** 2 憑證 */
  Voucher: 2,
  /** 3 外送 */
  Delivery: 3,
  /** 4 酒類外送 */
  WineDelivery: 4,
  /** 5 電影 */
  Movie: 5,
  /** 6 露營 */
  Camping: 6,
})

export const ProductDetailHtmlType = Object.freeze({
  /** Html */
  Html: 1,
  /** Image */
  Image: 2,
  /** Youtube */
  Youtube: 3,
  /** Unordered List */
  UnorderedList: 4,
  /** Ordered List */
  OrderedList: 5,
  /** List Item (`<li>`), tree node introduced by ZOEKIT-18441 */
  ListItem: 6,
})

export const ProductUpgradeMode = Object.freeze({
  /** 0 單選 */
  Single: 0,
  /** 1 複選 */
  Multiple: 1,
})

/** 方案上架的平台 */
export const ProductSupportPlatformEnum = Object.freeze({
  /** 0 FunNow */
  FunNow: 0,
  /** 1 FunBook */
  FunBook: 1,
})

export interface BranchProduct {
  bid: number
  branch_name: string
  rating: number
  area: string
  address: string
  lat: number
  lng: number
  product_id: number
  product_name: string
  fb_product_name: string
  description: string
  sales_mode: number
  vip_reward: string
  rrp: number
  cover_image: string
  images: any[]
  srrp: number
  symbol: string
  symbol_code: string
  currency_id: number
  discount_ration: number
  distance: string
  discount: number
  min_price: number
  duration: number
  is_hot: boolean
  is_now: boolean
  is_elite: boolean
  is_new_product: boolean
  is_limited: boolean
  is_favorite: boolean
  is_crossday: number
  is_cust_num: number
  is_book_seat_only: boolean
  is_paid_onsite: boolean
  has_detail: boolean
  onboard: number
  sell_time: string
  sell_time_type: string
  number_of_comments: number
  flash_time: string
  flash_time_type: string
  sub_item_min_sum: number
  sub_item_max_sum: number
  rank: number
}

export enum ProductCancelSettingMode {
  /** 0 天數，幾天前 */
  DAY,
  /** 1 日期，在哪個日期前 */
  DATE,
  /** 2 小時，幾小時前 */
  HOUR,
  /** 預訂時間 1 分鐘前，隨時可取消 */
  ANY_TIME,
}

export type ProductPenaltyRuleParams = {
  bookingTime?: string | null
  currencyId?: number | null
  paymentCurrencyId?: number | null
}

export type ProductPenaltyRuleGetParams = ToSnakeCaseKeys<ProductPenaltyRuleParams>

export type ProductPenaltyRuleResult = {
  mode: ProductCancelSettingMode
  free_cancel: {
    date?: string
    hour?: number | null
    day?: number
  }
  no_show: {
    currency_id: number
    currency_code: string
    amount: number
    payment_currency_id: number
    payment_amount: number
    payment_currency_code: string
  }
}

export type ProductInfoQueryParams = {
  bookingTime?: string
  userCurrencyId?: number
  paymentCurrencyId?: number
}

export interface ProductDetailInfo extends FunnowProductProductResponse {
  is_penalty: boolean
}

export enum ProductDiscountInfoType {
  /** 0 限時促銷 */
  FLASH_SALE = 0,
  /** 1 晚鳥促銷 */
  LAST_MINUTE = 1,
  /** 2 離峰促銷 */
  OFF_PEAK = 2,
}

// FunNow 專屬區塊（product-funnow-exclusive-sheet）用的 UI types
export enum BirthdayCardState {
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
  LOGGED_IN_NO_BIRTHDAY = 'LOGGED_IN_NO_BIRTHDAY',
  LOGGED_IN_THIS_MONTH = 'LOGGED_IN_THIS_MONTH',
  LOGGED_IN_OTHER_MONTH = 'LOGGED_IN_OTHER_MONTH',
}

interface RewardCardBase {
  title: string
  content: string
  backgroundColorClass: string
  foregroundColorClass: string
  isLocked: boolean
}

export interface MemberRewardCard extends RewardCardBase {
  type: 'member'
}

export interface VipRewardCard extends RewardCardBase {
  type: 'vip'
}

export interface BirthdayRewardCard extends RewardCardBase {
  type: 'birthday'
  birthdayState: BirthdayCardState
  hintText: string
}

export type RewardUiCard = MemberRewardCard | VipRewardCard | BirthdayRewardCard
